import { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import { SET_ACCESS_TOKEN, SET_PROFILE_AUTH, RESTE_ALL_AUTH_DATA } from "../../../../../redux/action/auth/type";

const OtpStep = ({ phone, otp, setOtp, onBack, onSuccessClose }) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const accessToken = useSelector((state) => state.auth.accessToken);
    const [cookies] = useCookies(["refreshToken"]);
    const profile = useSelector((state) => state.auth.profile)

    const [loading, setLoading] = useState(false);

    // تبدیل اعداد فارسی/عربی به انگلیسی
    const convertToEnglishDigits = (value) => {
        const persian = "۰۱۲۳۴۵۶۷۸۹";
        const arabic = "٠١٢٣٤٥٦٧٨٩";
        return value
            .split("")
            .map((c) => 
                persian.includes(c) ? persian.indexOf(c) :
                arabic.includes(c) ? arabic.indexOf(c) : c
            )
            .join("");
    };

    const handleOtpChange = (e) => {
        let value = convertToEnglishDigits(e.target.value);
        value = value.replace(/\D/g, ""); // فقط عدد
        setOtp(value);
    };

    const refreshAccess = async () => {
        try {
            const res = await axios.post(
                "https://my-sarad-back.liara.run/api/auth/refresh-token",
                { refreshToken: cookies?.refreshToken }
            );

            const newAccess = res.data?.accessToken;

            dispatch({
                type: SET_ACCESS_TOKEN,
                payload: newAccess
            });

            return newAccess;
        } catch (err) {
            return null;
        }
    };

    const sendVerifyRequest = async (token) => {
        return axios.post(
            "https://my-sarad-back.liara.run/api/user/verify-phone-change",
            { code: otp },
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );
    };

    const handleVerify = async () => {
        if (!otp || otp.length < 4) {
            toast.error("کد تایید معتبر نیست");
            return;
        }

        setLoading(true);

        let token = accessToken;

        // اگر access token نداشتیم → اول رفرش کنیم
        if (!token) {
            token = await refreshAccess();
            if (!token) {
                toast.error("نشست شما منقضی شده، لطفا دوباره وارد شوید");
                dispatch({ type: RESTE_ALL_AUTH_DATA });
                navigate("/auth");
                setLoading(false);
                return;
            }
        }

        try {
            await sendVerifyRequest(token);
        } catch (err) {
            const status = err?.response?.status;

            // اگر access token منقضی شده بود → دوباره refresh بزنیم
            if (status === 401 || status === 403) {
                const newAccess = await refreshAccess();

                if (!newAccess) {
                    toast.error("نشست شما منقضی شده، لطفا دوباره وارد شوید");
                    dispatch({ type: RESTE_ALL_AUTH_DATA });
                    navigate("/auth");
                    setLoading(false);
                    return;
                }

                // تلاش دوباره
                try {
                    await sendVerifyRequest(newAccess);
                } catch (error) {
                    const msg = error?.response?.data?.message || "کد وارد شده صحیح نیست";
                    toast.error(msg);
                    setLoading(false);
                    return;
                }
            } else {
                const msg = err?.response?.data?.message || "کد وارد شده صحیح نیست";
                toast.error(msg);
                setLoading(false);
                return;
            }
        }

        // اگر اینجا رسید یعنی همه چیز OK است

        // شماره جدید را روی Redux ذخیره کن
        dispatch({
            type: SET_PROFILE_AUTH,
            payload: {
                ...profile,
                phone: phone
            }
        });

        toast.success("شماره تلفن شما با موفقیت تغییر کرد");

        // بستن Sheet یا Modal
        onSuccessClose();

        setLoading(false);
    };

    return (
        <div className="p-6 space-y-6">

            <div className="text-center space-y-6">
                <div>
                    <p className="text-sm text-slate-400">کد ارسال شده به</p>
                    <div className="font-bold bg-slate-100 w-fit px-4 mx-auto rounded-md py-1 text-slate-500">
                        {phone}
                    </div>
                </div>

                <h3 className="text-lg font-bold text-slate-800">
                    کد ارسالی را وارد بفرمایید
                </h3>
            </div>

            <input
                type="text"
                value={otp}
                onChange={handleOtpChange}
                maxLength={6}
                placeholder="کد تایید"
                className="w-full h-12 rounded-xl border-[1.5px] border-slate-300 px-4 text-center tracking-widest text-lg focus:outline-none focus:border-[#8b6bd9]"
            />

            <button
                onClick={handleVerify}
                disabled={loading}
                className={`w-full h-12 rounded-xl bg-gradient-to-r from-[#543389] to-[#8b6bd9] text-white font-bold shadow-lg ${
                    loading ? "opacity-60 cursor-not-allowed" : ""
                }`}
            >
                {loading ? "در حال بررسی..." : "ثبت و تایید شماره جدید"}
            </button>

            <button
                onClick={onBack}
                className="text-xs mx-auto w-fit block text-purple-500 hover:underline"
            >
                اصلاح شماره موبایل
            </button>

        </div>
    );
};

export default OtpStep;